var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.articleData.title))]),_c('div',{staticClass:"fuwenben",domProps:{"innerHTML":_vm._s(_vm.articleData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }